import { notifications } from "@mantine/notifications";
import { adminErrorMessage } from "../api.ts";

/** 失败 toast：带标题、自动换行、停留更久，避免只闪一句「系统错误」。 */
export const notifyAdminError = (e: unknown, title = "操作失败"): void => {
  notifications.show({
    color: "red",
    title,
    message: adminErrorMessage(e),
    autoClose: 10_000,
  });
};

export const notifyAdminSuccess = (message: string, title = "已完成"): void => {
  notifications.show({
    color: "green",
    title,
    message,
    autoClose: 5_000,
  });
};
